module.exports = __webpack_public_path__ + "static/coach-hire-services-coast-country-day-trips-071597606914d517b653cdce331a6bbe.jpg";